import React from "react";

import { InputGroup } from "react-bootstrap";
import Select from "react-select";
import { Label } from "reactstrap";

const SelectFilter = ({
  title,
  placeholder,
  value,
  setFunction,
  options,
  disabled,
  loading
}) => (
  <>
    {title && (
      <div className="w-100 text-ellipsis">
        <Label className="d-block w-100 text-ellipsis">{title}</Label>
      </div>
    )}
    <InputGroup>
      <Select
        className="w-100"
        placeholder={placeholder}
        onChange={e => {
          e ? setFunction(parseInt(e.value)) : setFunction(null);
        }}
        isDisabled={disabled}
        value={options?.find(option => option.value === value)}
        options={options}
        isLoading={loading}
        loadingMessage={() => "Carregando..."}
        isClearable
      />
    </InputGroup>
  </>
);

export default SelectFilter;
